function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "location_off_24px"
}, React.createElement("path", {
  id: "icon/communication/location_off_24px",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.17998 4.125C9.42998 2.97501 11.09 2.26501 12.93 2.26501C16.8 2.26501 19.93 5.39502 19.93 9.26501C19.93 10.835 19.3 12.625 18.42 14.375L14.87 10.825C15.22 10.395 15.43 9.85501 15.43 9.26501C15.43 7.88501 14.31 6.76501 12.93 6.76501C12.34 6.76501 11.8 6.97501 11.37 7.315L8.17998 4.125ZM3.63994 5.23502C3.24998 4.84503 3.24998 4.21503 3.63994 3.82501C3.82677 3.63776 4.08043 3.53253 4.34496 3.53253C4.60948 3.53253 4.86314 3.63776 5.04997 3.82501L20.36 19.155C20.75 19.545 20.75 20.175 20.36 20.565C19.97 20.955 19.34 20.955 18.9499 20.565L16.3 17.915C15.31 19.365 14.34 20.595 13.69 21.375C13.29 21.855 12.56 21.855 12.16 21.375C10.35 19.185 5.92998 13.435 5.92998 9.26501C5.92998 8.73502 5.99998 8.21503 6.10997 7.70502L3.63994 5.23502Z",
  fill: "black",
  fillOpacity: 0.54
}));

var SvgPenimbunanKanal = function SvgPenimbunanKanal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPenimbunanKanal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/penimbunan_kanal.d5b7bec1.svg";
export { ForwardRef as ReactComponent };